/**
 * Formatiert ein reines ISO-Datum (`YYYY-MM-DD`) in der aktiven Locale.
 *
 * `new Date('2026-03-01')` parst laut Spec als UTC-Mitternacht, `Intl.DateTimeFormat`
 * formatiert aber in der lokalen Zone → westlich von UTC käme ein Tag zu früh heraus.
 * Das angehängte `T00:00:00` erzwingt die Auslegung als LOKALE Mitternacht. Kalendertage
 * ohne Zeitzone (z. B. `kl_followup_date`) dürfen sich beim Anzeigen nicht verschieben.
 */
export function formatIsoDate(isoDate: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(
    new Date(`${isoDate}T00:00:00`),
  );
}

/**
 * Formatiert einen Zeitpunkt (ISO-Datum mit Uhrzeit) in der aktiven Locale und der Zeitzone des
 * Browsers. `datum` zeigt nur den Kalendertag (z. B. News), `datum_uhrzeit` zusätzlich die Uhrzeit.
 */
export function formatZeitpunkt(
  iso: string,
  locale: string,
  art: 'datum' | 'datum_uhrzeit' = 'datum_uhrzeit',
): string {
  const optionen: Intl.DateTimeFormatOptions =
    art === 'datum' ? { dateStyle: 'medium' } : { dateStyle: 'medium', timeStyle: 'short' };
  return new Intl.DateTimeFormat(locale, optionen).format(new Date(iso));
}
